import "@telekom-ods/react-ui-kit/style.css";

import Routes from "core/routes/Route";

export function App() {
	return <Routes />;
}

export default App;
